import { useQuery } from 'react-query';
import axios from 'axios';
import { useAppSelector } from '../../../../Config/Hooks';
import DEFAULT_FOOTER_CONFIG, { FooterConfig } from '../../../../Config/FooterConfig';

interface Configuration {
  id: string;
  name: string;
  value: string;
  description?: string;
}

async function fetchCallPortalUrlFromAPI(): Promise<string> {
  try {
    const response = await axios.get<{
      data: Configuration;
    }>('/api/configuration/callportalurl', { timeout: 30000 });

    if (
      response.data?.data?.value &&
      typeof response.data.data.value === 'string' &&
      response.data.data.value.trim()
    ) {
      return response.data.data.value.trim();
    }
  } catch (error) {
    console.warn('Failed to fetch callportalurl from API, using default URL');
    if (process.env.NODE_ENV === 'development') {
      console.debug('Error details:', error);
    }
  }

  return DEFAULT_FOOTER_CONFIG.callPortalUrl;
}

async function fetchFooterConfig(): Promise<FooterConfig> {
  const callPortalUrl = await fetchCallPortalUrlFromAPI();

  return {
    callPortalUrl,
    linkedInUrl: DEFAULT_FOOTER_CONFIG.linkedInUrl,
    instagramUrl: DEFAULT_FOOTER_CONFIG.instagramUrl,
    companyInfo: DEFAULT_FOOTER_CONFIG.companyInfo,
  };
}

export const useFooterConfigReactQuery = () => {
  const isAuthenticated = useAppSelector((state: any) => state.authentication.isAuthenticated);

  return useQuery(
    ['footerConfig'],
    () => fetchFooterConfig(),
    {
      enabled: !!isAuthenticated,
      staleTime: 60 * 60 * 1000,
      keepPreviousData: true,
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
    }
  );
};

export const getDefaultFooterConfig = (): FooterConfig => {
  return {
    ...DEFAULT_FOOTER_CONFIG,
  };
};
